import * as dom from "OK/utils/dom";

const ACTIVE_CLASS = 'toolbar_dropdown_w_hover';

class VkEcosystem {
    private element!: HTMLElement;
    private card!: HTMLElement;

    closeDropdown = () => {
        this.element.classList.remove(ACTIVE_CLASS);
        this.card.setAttribute('aria-expanded', 'false');
        document.removeEventListener('mousedown', this.documentClick, false);
    };

    documentClick = (e:MouseEvent) => {
        var tobeHidden = false;
        if (e.target instanceof Element) {
            if (!this.element.contains(e.target)) {
                tobeHidden = true;
            }
        }

        if (tobeHidden) {
            this.closeDropdown();
        }
    };

    cardClick = () => {
        if (this.element.classList.contains(ACTIVE_CLASS)) {
            this.closeDropdown();
        } else {
            this.element.classList.add(ACTIVE_CLASS);
            this.card.setAttribute('aria-expanded', 'true');
            document.addEventListener('mousedown', this.documentClick, false);

            let pixel = this.element.dataset.pixel;
            if(pixel !== "") {
                OK.sendBeacon(pixel, {});
            }
        }
    };

    activate(el: HTMLElement) {
        this.element = el;
        this.card = dom.firstByClass(this.element, 'toolbar_nav_a__vk_ecosystem')!;
        this.card.addEventListener('click', this.cardClick, false);
    }

    deactivate(el: HTMLElement) {
        this.card.removeEventListener('click', this.cardClick, false);
        document.removeEventListener('mousedown', this.documentClick);
    }
}

export default VkEcosystem;
